var React = require('react');

require('./AdultJuniorBenefits.scss');

const imageOneSmall = require('images/ajb/ajb-one-small-min.png');
const imageOneLarge = require('images/ajb/ajb-one-large-min.png');
const imageTwoSmall = require('images/ajb/ajb-two-small-min.png');
const imageTwoLarge = require('images/ajb/ajb-two-large-min.png');

const benefitOptions = {
    ticketAccess: {
        text: 'Priority ticket access',
        icon: require('images/ajb/ticket.png')
    },
    ticketExchange: {
        text: 'Access ticket exchange',
        icon: require('images/ajb/arrow.png')
    },
    ticketShare: {
        text: 'Ticket share',
        icon: require('images/ajb/thumb.png')
    },
    oneHotspurMoments: {
        text: 'One Hotspur moments',
        icon: require('images/ajb/smile.png')
    },
    seasonTicketWaitingList: {
        text: 'Season ticket waiting list',
        icon: require('images/ajb/list.png')
    },
    discountVouchers: {
        text: 'Discount vouchers',
        icon: require('images/ajb/discount.png')
    },
    membershipPack: {
        text: 'Membership pack',
        icon: require('images/ajb/case.png')
    },
    freeStadiumTour: {
        text: 'Free stadium tour',
        icon: require('images/ajb/stadium.png')
    },
    freeEntryToWomensMatches: {
        text: 'Free entry to womens matches',
        icon: require('images/ajb/football.png')
    },
    tenPercentOffGfdCourses: {
        text: '10% off Football Development Programmes',
        icon: require('images/ajb/clipboard.png')
    }
};

const adultBenefits = [
    benefitOptions.ticketAccess,
    benefitOptions.ticketExchange,
    benefitOptions.ticketShare,
    benefitOptions.oneHotspurMoments,
    benefitOptions.seasonTicketWaitingList,
    benefitOptions.discountVouchers
];

const juniorBenefits = [
    benefitOptions.ticketAccess,
    benefitOptions.membershipPack,
    benefitOptions.oneHotspurMoments,
    benefitOptions.freeStadiumTour,
    benefitOptions.freeEntryToWomensMatches,
    benefitOptions.tenPercentOffGfdCourses
];

class AdultJuniorBenefitsModule extends React.Component {
	
	render() {
        const classPrefix = 'c-adult-junior-benefits';
		return (
            <div className="c-section c-section--flush c-section--h c-section--hide-overflow">
                <div className="c-section__inner">
                    <div className="c-section__inner__inner">
                        <div className={`${classPrefix}`}>

                            <div className={`${classPrefix}__item`}>
                                <div className={`${classPrefix}__item-image`}>
                                    {/* Removed image lazy loading is it was causing issues on iPads in landscape and is a common bug */}
                                    <img src={imageOneSmall} alt="" className={`${classPrefix}__item-image-element ${classPrefix}__item-image-element--small`} />
                                    <img src={imageOneLarge} alt="" className={`${classPrefix}__item-image-element ${classPrefix}__item-image-element--large`} />
                                </div>

                                <div className={`${classPrefix}__item-content`}>
                                    <h2 className={`${classPrefix}__item-title`}><span className={`${classPrefix}__break`}>Adult</span> <span className={`${classPrefix}__break`}>Membership</span> <span className={`${classPrefix}__break`}>Benefits</span></h2>
                                    <div className={`${classPrefix}__item-benefits`}>
                                    {adultBenefits.map((benefit) => {
                                        return (
                                            <div className={`${classPrefix}__benefits-item`}>
                                                <div className={`${classPrefix}__benefits-item-image`}>
                                                    <img src={benefit.icon} alt="" loading="lazy" className={`${classPrefix}__benefits-item-image-element`} />
                                                </div>
                                                <p className={`${classPrefix}__benefits-item-text`}>{benefit.text}</p>
                                            </div>
                                        );
                                    })}
                                    </div>
                                    <div className={`${classPrefix}__item-action`}>
                                        <a href="#member-benefits-table" className="c-button c-button--small c-button--down-arrow">View all adult benefits</a>
                                    </div>
                                </div>
                            </div>

                            <div className={`${classPrefix}__item ${classPrefix}__item--switch`}>
                                <div className={`${classPrefix}__item-image`}>
                                    <img src={imageTwoSmall} alt="" loading="lazy" className={`${classPrefix}__item-image-element ${classPrefix}__item-image-element--small`} />
                                    <img src={imageTwoLarge} alt="" loading="lazy" className={`${classPrefix}__item-image-element ${classPrefix}__item-image-element--large`} />
                                </div>

                                <div className={`${classPrefix}__item-content`}>
                                    <h2 className={`${classPrefix}__item-title`}><span className={`${classPrefix}__break`}>Junior</span> <span className={`${classPrefix}__break`}>Membership</span> <span className={`${classPrefix}__break`}>Benefits</span></h2>
                                    <div className={`${classPrefix}__item-benefits`}>
                                        {juniorBenefits.map((benefit) => {
                                            return (
                                                <div className={`${classPrefix}__benefits-item`}>
                                                    <div className={`${classPrefix}__benefits-item-image`}>
                                                        <img src={benefit.icon} alt="" loading="lazy" className={`${classPrefix}__benefits-item-image-element`} />
                                                    </div>
                                                    <p className={`${classPrefix}__benefits-item-text`}>{benefit.text}</p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className={`${classPrefix}__item-action`}>
                                        <a href="#member-benefits-table" className="c-button c-button--small c-button--down-arrow">View all junior benefits</a>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

module.exports = AdultJuniorBenefitsModule;



// WEBPACK FOOTER //
// ./src/components/AdultJuniorBenefits/AdultJuniorBenefitsModule.js